<app-tb-accordion
    *transloco="let tAdvancedOptions; read: 'advanced_options'"
    [title]="tAdvancedOptions('views')"
    [description]="tAdvancedOptions('options_description', { conf: 'views' })"
    [expanded]="true"
    [background]="true"
    [settingsShow]="true"
    (callAdvanced)="openViewConfiguration()"
>
    <div class="w-full flex bg-neutral2 px-4 pb-4">
        <div class="flex flex-col w-full gap-5 p-4 rounded-lg bg-white">
            @for (schema of schemaTabs(); track schema.id) {
                <div class="flex flex-row">
                    <div class="flex-1 body-2">
                        <div class="flex items-center gap-1">
                            <app-tb-icon [icon]="schema.icon!"></app-tb-icon>
                            <span>
                                {{ schema.name }}
                            </span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <app-view-section-content
                            [views]="templateViewsTypeUI[schema.id]"
                        ></app-view-section-content>
                    </div>
                </div>
            }
        </div>
    </div>
</app-tb-accordion>
